// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3v3AJ","rightAdornment":"Header_rightAdornment__34GW6"};